import React, { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { toast } from "react-toastify";
import styles from "./ModalComp.module.css";
import { useSelector } from "react-redux";
import { TextInput, FilePicker, Textarea, Button } from "evergreen-ui";
import Header from "../../Header/Header";
import moment from "moment";
import { validateAmount} from "../../../Utils/Validation";
export const ModalComp = ({
  open,
  onOpenModal,
  onCloseModal,
  handleDisablebtn,
  detail,
}) => {
  const [btnLoading, setbtnLoading] = useState(false);
  const [bills, setBills] = useState({
    poNumber: detail && detail.po_display_number,
    billNumber: "",
    billDate: "",
    billAmount: "",
    notes: "",
    communityId: "",
    document: {},
  });
  const { vendorId } = useSelector((state) => state.auth);
  const [communities, setCommunities] = useState("");
  const getMappedCommunities = () => {
    const payload = {
      vendor_id: vendorId
    };
    fetch(process.env.REACT_APP_API_URL + "/api/vendor/mapped_communities", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "content-type": "application/json" },
    })
      .then((d) => d.json())
      .then((res) => {
        setCommunities(res.response);
      })
      .catch((err) => console.log("e", err));
  };
  const handleBills = (e) => {
    const { name, value } = e.target;
    setBills({
      ...bills,
      [name]: value,
    });
  };
  const handleSubmit = () => {
    // toast.dismiss();
    setbtnLoading(true);
    const payload = {
      po_number: detail && detail.bill_id === null ? detail.po_id : null,
      bill_number: bills.billNumber,
      bill_date: bills.billDate,
      bill_amount: bills.billAmount,
      notes: bills.notes,
      vendor_id: vendorId,
      created_by: vendorId,
      community_id: bills.communityId === null ?  detail.community_id : bills.communityId,
      due_date: moment(new Date()).format("YYYY-MM-DD"),
      rcm_flag: 0,
      rounding_off: "none",
      tds: 0,
      document: bills.document,
    };
    if (bills.poNumber == "" && detail.bill_id === null) {
      toast.error("PO Number field is required");
      setbtnLoading(false);
    } else if (bills.communityId == "") {
      toast.error("Community field is required");
      setbtnLoading(false);
    } else if (bills.billNumber == "") {
      toast.error("Bill Number field is required");
      setbtnLoading(false);
    } else if (bills.billDate == "") {
      toast.error("Bill Date field is required");
      setbtnLoading(false);
    } else if (bills.billAmount == "") {
      toast.error("Bills Amount field is required");
      setbtnLoading(false);
    } else if(!validateAmount(bills.billAmount)) {
      toast.error("Bills Amount should be a valid amount");
      setbtnLoading(false); 
    } else if (bills.notes == "") {
      toast.error("Notes field is required");
      setbtnLoading(false);
    } else if (fileSizeError) {
      toast.error(`File size exceeds the maximum limit of ${MAX_FILE_SIZE_MB} MB.`);
      setbtnLoading(false);
    } else if (Object.keys(bills.document).length === 0) {
      toast.error("Bill attachment is required");
      setbtnLoading(false);
    } else {
      fetch(process.env.REACT_APP_API_URL + "/api/vendorpo/storePoBill", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setbtnLoading(false);

          if (res.status === true) {
            toast(`${res.message}`, {
              type: "success",
            });
            setBills({
              billNumber: "",
              billDate: "",
              billAmount: "",
              notes: "",
              communityId: "",
              document: {},
            });
            handleDisablebtn();
            onCloseModal();
          } else {
            toast(`${res.message}`, {
              type: "error",
            });
            // setBills({
            //   billNumber: "",
            //   billDate: "",
            //   billAmount: "",
            //   notes: "",
            //   communityId: "",
            //   document: {},
            // });
          }
        })
        .catch((err) => {
          console.log("e", err);
        });
    }
  };

  const MAX_FILE_SIZE_MB = 20;
  const [isLoading, setIsLoading] = useState(false);
  const [fileSizeError, setFileSizeError] = useState(false);
  const handleUpload = (event, name) => {
    const file = event[0];
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      toast.error(`File size exceeds the maximum limit of ${MAX_FILE_SIZE_MB} MB.`);
        setBills({
        ...bills,
        document: {}, // Clear the document state
      });
      setFileSizeError(true); // Set the size error flag
      setIsLoading(false);
      setbtnLoading(false);
      return;
    }else {
      setFileSizeError(false); // Clear the size error flag if valid
    }

    const formData = new FormData();
    formData.append("file", event[0]);
    setIsLoading(true);
    setbtnLoading(true);

    fetch(process.env.REACT_APP_API_URL + "/api/FileUpload", {
      method: "POST",
      body: formData,
    })
      .then((d) => d.json())
      .then((res) => {
        setBills({
          ...bills,
          document: [
            {
              unique: name,
              path: res.path,
              url: res.url,
              name: res.name,
              file_size: res.size,
              file_type: res.type,
            },
          ],
        });
        setIsLoading(false);
        setbtnLoading(false);
      });
  };
  useEffect(() => {
    getMappedCommunities();
    setBills({
      ...bills,
      poNumber: detail && detail.po_display_number !== null ? detail.po_display_number : null,
      communityId: detail && detail.bill_id !== null? detail.community_id : null,
    });
  }, [detail]);
  return (
    <div>
      {/* <button onClick={onOpenModal}>Open modal</button> */}
      <Modal open={open} showCloseIcon={false} onClose={onCloseModal} center>
        <div
          style={{ marginLeft: "10px", marginTop: "0", marginRight: "10px" }}
        >
          <Header title={"Submit Bill"} customMg={"0px"} />
          <div className={styles.MainDivSB}>
            <div className="flexInput">
              {detail?.bill_id === null ? (<div>
                <label className={styles.LLabel} htmlFor="">
                  PO NUMBER
                </label>
                <br />
                <TextInput
                  disabled
                  className={styles.mgbottominputSB}
                  width={300}
                  height={40}
                  placeholder="Enter Po Number"
                  name="poNumber"
                  value={bills.poNumber}
                  onChange={handleBills}
                />
              </div>) : (<div style={{ width: "50%" }}>
                <label className={styles.LLabel} htmlFor="">
                  Community <span>*</span>
                </label>
                <br />
                <select
                  className={styles.communityInputSelect}
                  width={300}
                  height={40}
                  placeholder="Select Community"
                  name="communityId"
                  onChange={handleBills}
                  required
                >
                  <option value=''>Select Community</option>
                  {communities &&
                    communities.map((e) =>
                        <option value={e.community_id}>{e.community_name}</option>
                    )}
                </select>
              </div>)}
              <div>
                <label className={styles.LLabel} htmlFor="">
                  BILL NUMBER <span>*</span>
                </label>
                <br />
                <TextInput
                  className={styles.mgbottominputSB}
                  width={300}
                  height={40}
                  placeholder="Enter Bill Number"
                  name="billNumber"
                  value={bills.billNumber}
                  onChange={handleBills}
                />
              </div>
            </div>
            <div className="flexInput">
              <div>
                <label className={styles.LLabel} htmlFor="">
                  BILL DATE <span>*</span>
                </label>
                <br />
                <input
                  className={styles.mgbottominputSB}
                  type="date"
                  placeholder="Select Date"
                  name="billDate"
                  value={bills.billDate}
                  onChange={handleBills}
                  required
                />
              </div>
              <div>
                <label className={styles.LLabel} htmlFor="">
                  BILL AMOUNT(INCL.TAX) <span>*</span>
                </label>
                <br />
                <TextInput
                  className={styles.mgbottominputSB}
                  width={300}
                  height={40}
                  placeholder="Enter Bill Amount"
                  name="billAmount"
                  value={bills.billAmount}
                  onChange={handleBills}
                />
              </div>
            </div>
            <div className="flexInput">
              <div>
                <label className={styles.LLabel} htmlFor="">
                  Attach Bill <span>*</span>
                </label>
                <br />
                <FilePicker
                  multiple={false}
                  width={300}
                  height={40}
                  accept=".pdf, .jpg, .png, .jpeg"
                  placeholder="Browse..."
                  onChange={(e) => handleUpload(e, "attachbill")}
                  required
                />
                <p className="subLabel">Supports PDF, JPG, JPEG, PNG</p>
                {/* Loader*/}
                {isLoading && (
                  <div>
                    <p>Uploading...</p>
                  </div>
                )}
              </div>
              <div>
                <label className={styles.LLabel} htmlFor="">
                  NOTES <span>*</span>
                </label>
                <br />
                <Textarea
                  placeholder="Notes"
                  width={300}
                  height={40}
                  name="notes"
                  value={bills.notes}
                  onChange={handleBills}
                />
              </div>
            </div>
            <div className={styles.btnDiv}>
              <Button
                className={styles.submitBtnPO}
                id="poppinFont"
                marginRight={16}
                // isLoading={btnLoading}
                disabled={btnLoading}
                onClick={handleSubmit}
              >
                {btnLoading && (
                  <i
                    className="fa fa-spinner fa-spin "
                    style={{ color: "white", marginRight: "10px" }}
                  ></i>
                )}
                Submit
              </Button>
              <Button
                className="poppinFont"
                marginRight={16}
                onClick={() => onCloseModal()}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
